<template>
    <div :class="selectList.length >0?'warpd':'warpd none'">
        <div class="noneWarp" v-show="selectList.length == 0">
            <img src="../../assets/img/not_found_data.png" alt="">
        </div>
        <iframe width="100%" height="100%" :src="iframeSrc" frameborder="0"></iframe>
        <div class="dimg" @click="$emit('showDiagram',false)">
            取消全屏<img src="../../assets/img/escaOut.png" alt="">
        </div>
        
        <div class="diagramName">
            <!-- {{currentName}} -->
        </div>

        <div class="tab">
            <div class="previous">
                第{{selectList.length >0? idx + 1:0}}页/第{{selectList.length}}页
            </div>
            <div :class="minidx?'previous min':'previous'" @click="up">
                上一页
            </div>
            <div :class="maxidx?'previous max':'previous'" @click="down">
                下一页
            </div>
            <div :class="selectList.length == 0?'previous ban':'previous'" @click="tabName">
                跳转
            </div>

            <div class="list" v-show="isShow">
                <SelectList :selectList="selectList" @tabTitle="tabTitle" keyk="id" keyval="name"/>
            </div>
        </div>
    </div>
</template>

<script>
import { GetDistribution } from '../../components/Request'
const SelectList = () => import('../../components/title/selectList.vue')

export default {
    data(){
        return {
            iframeSrc:'',
            selectList:[],
            isShow:false,
            currentName:'',
            idx:0
        }
    },
    components:{
        SelectList
    },
    mounted(){
        this.getProjectDiagram()
    },
    computed:{
        minidx(){
            if(this.idx == 0){
                return true
            }else{
                return false
            }
        },
        maxidx(){
            if(this.idx == this.selectList.length - 1 || this.selectList.length ==0){
                return true
            }else{
                return false
            }
        }
    },
    methods:{
        // 获取当前项目所有接线图
        async getProjectDiagram(){
            let that = this
            let data = {
                projectId:this.$store.state.projectId
            }
            let res = await GetDistribution(data)
            this.selectList = res.data.data.result
            this.selectList.forEach((item,index) =>{
                that.$set(item,'id',index)
            })
            console.log(this.selectList);
            this.currentName = res.data.data.result[0].name
            this.iframeSrc = res.data.data.result[0].url
        },
        tabName(){
            this.isShow = !this.isShow 
        },
        tabTitle(title){
            this.currentName = title.name
            this.isShow = false
            this.iframeSrc = title.url
            this.selectList.forEach((item,index) =>{
                if(item.name == title.name){
                    this.idx = index
                }
            })
        },
        up(){
            if(this.idx == 0){
                this.idx = 0
            }else{
                console.log(this.idx);
                this.idx --
                console.log(this.idx);

                this.currentName = this.selectList[this.idx].name
                this.iframeSrc = this.selectList[this.idx].url
            }
        },
        down(){
            if(this.idx == this.selectList.length - 1){
                this.idx = this.selectList.length - 1
            }else{
                console.log(this.idx);
                this.idx ++
                console.log(this.idx);

                this.currentName = this.selectList[this.idx].name
                this.iframeSrc = this.selectList[this.idx].url
            }
        }
    }
}
</script>

<style lang="less" scoped>
    .warpd{
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 11;
        .noneWarp{
            width: 25vw;
            height: 30vh;
            text-align: center;
            margin: 40vh auto;
            font-size: 1vw;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .diagramName{
            width: 100%;
            color: #fff;
            font-size: 28rem;
            text-align: center;
            line-height: 5vh;
            position: absolute;
            right: 0;
            top: 4vh;
        }
        .dimg{
            height: 30rem;
            position: absolute;
            right: 2vw;
            bottom: 5vh;
            color: #000;
            font-size: 20rem;
            cursor: pointer;
            img{
                vertical-align: middle;
                width: 30rem;
                height: 30rem;
                margin-left: 5rem;
            }
        }
        .tab{
            width: 20vw;
            height: 3vh;
            line-height: 2.8vh;
            position: absolute;
            right: 2vw;
            top: 5vh;
            font-size: 20rem;
            display: flex;
            flex-direction: row;
            color: #000;
            justify-content: space-between;
            .previous{
                height: 100%;
                padding:0 0.5vw ;
                border: 2px dashed #000;
                cursor: pointer;
            }
            .previous:nth-child(1){
                border: 2px dashed transparent;
                padding: 0;
                cursor: default;
            }
            .previous:nth-child(4){
                padding: 0 1vw;
            }

            .ban,.min,.max{
                color:#999 ;
                cursor: not-allowed;
            }

        
            .list{
                width: 9vw;
                max-height: 15vh;
                background:#fff;
                position: absolute;
                border-radius: 5px;
                top: 5vh;
                right: 0;
            }
        }
    }
    .none{
        background-color: #fff;
    }
</style>